import ReportsPanel from './reportsPanel.tsx';

export default ReportsPanel;